require('./core');

require('./components/anonymous_landing/anonymous_landing');



// WEBPACK FOOTER //
// ./app/lib/anonymous_landing/main.ts